import { Lock } from "lucide-react";
import { FaCcStripe, FaCcVisa, FaCcMastercard, FaCcApplePay } from "react-icons/fa";

const LOGOS = [["Stripe", FaCcStripe], ["Visa", FaCcVisa], ["Mastercard", FaCcMastercard], ["Apple Pay", FaCcApplePay]];

export const SecurePayment = () => (
  <div className="flex items-center gap-4" data-testid="footer-secure-payment">
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.12em] text-white/70 uppercase">
      <Lock size={13} /> Pago seguro
    </span>
    <div className="flex items-center gap-2.5 text-white/80">
      {LOGOS.map(([name, Icon]) => <Icon key={name} size={30} title={name} aria-label={name} data-testid={`footer-logo-${name.toLowerCase().replace(/ /g, "-")}`} />)}
    </div>
  </div>
);
